module.exports = __webpack_public_path__ + "img/15.d478a0d8.jpg";